module.exports = __webpack_public_path__ + "media/02_ASANBUDAPEST-BEATS02.3fd9953a.mp3";